import z from 'zod';
import { DBPermissionGroupGroupIdSchema } from '../permissionGroups/schemas';
import {
  DBPermissionPermissionIdSchema,
  PermissionSourceSchema,
  PermissionValueSchema,
} from '../permissions/schemas';
import { UserIdSchema } from '../users/schemas';

/**
 * Shared & Helper Schemas
 */

export const DBUserPermissionSourceSchema = z.union([
  z.lazy(() => PermissionSourceSchema),
  z.lazy(() => DBPermissionGroupGroupIdSchema),
]);

export const UserPermissionSourceSchema = DBUserPermissionSourceSchema;

export const DBUserPermissionGenericPermissionsSchema = z.record(
  z.lazy(() => DBPermissionPermissionIdSchema),
  z.object({
    sources: z.array(DBUserPermissionSourceSchema),
  })
);

export const UserPermissionGenericPermissionsSchema = z.array(
  z.object({
    value: z.lazy(() => PermissionValueSchema),
    sources: z.array(UserPermissionSourceSchema),
  })
);

/**
 * DB Schemas
 */

export const DBUserPermissionUserIdSchema = z.lazy(() => UserIdSchema);
export const DBUserPermissionPermissionsSchema = DBUserPermissionGenericPermissionsSchema;
export const DBUserPermissionExamPermissionsSchema = DBUserPermissionGenericPermissionsSchema;
export const DBUserPermissionNotePermissionsSchema = DBUserPermissionGenericPermissionsSchema;
export const DBUserPermissionVideoPermissionsSchema = DBUserPermissionGenericPermissionsSchema;
export const DBUserPermissionTutorialPermissionsSchema = DBUserPermissionGenericPermissionsSchema;
export const DBUserPermissionPermissionGroupsSchema = z.record(
  z.lazy(() => DBPermissionGroupGroupIdSchema),
  z.object({}).strict()
);

export const DBUserPermissionSchema = z.object({
  userId: DBUserPermissionUserIdSchema,
  // .optional() indicates to ElectroDB that keys of these dynamic fields may be deleted
  permissions: DBUserPermissionPermissionsSchema.optional(),
  examPermissions: DBUserPermissionExamPermissionsSchema.optional(),
  notePermissions: DBUserPermissionNotePermissionsSchema.optional(),
  videoPermissions: DBUserPermissionVideoPermissionsSchema.optional(),
  tutorialPermissions: DBUserPermissionTutorialPermissionsSchema.optional(),
  permissionGroups: DBUserPermissionPermissionGroupsSchema.optional(),
});

/**
 * Client Schemas
 */
export const UserPermissionUserIdSchema = DBUserPermissionUserIdSchema;
export const UserPermissionPermissionsSchema = UserPermissionGenericPermissionsSchema;
export const UserPermissionExamPermissionsSchema = UserPermissionGenericPermissionsSchema;
export const UserPermissionNotePermissionsSchema = UserPermissionGenericPermissionsSchema;
export const UserPermissionVideoPermissionsSchema = UserPermissionGenericPermissionsSchema;
export const UserPermissionTutorialPermissionsSchema = UserPermissionGenericPermissionsSchema;
export const UserPermissionPermissionGroupsSchema = z.array(
  z.lazy(() => DBPermissionGroupGroupIdSchema)
);

export const UserPermissionSchema = z.object({
  userId: UserPermissionUserIdSchema,
  permissions: UserPermissionPermissionsSchema.default([]),
  examPermissions: UserPermissionExamPermissionsSchema.default([]),
  notePermissions: UserPermissionNotePermissionsSchema.default([]),
  videoPermissions: UserPermissionVideoPermissionsSchema.default([]),
  tutorialPermissions: UserPermissionTutorialPermissionsSchema.default([]),
  permissionGroups: UserPermissionPermissionGroupsSchema.default([]),
});
